<template>
  <div class="after-withdraw">
    <nav-header module="提现"></nav-header>
    <div class="container">
      <div class="dl">
        <div class="dt"></div>
        <div class="dd">
          <div class="msg">提现申请已提交，等待速派处理。</div>
          <p class="desc">如果信息填写有误，导致提现失败，资金将自动退还到您的余额。</p>
          <ul class="step-list">
            <li v-for="(item,index) in steps" :key="index" :class="{on:index<=current-1}">
              <div class="num"><i>{{index+1}}</i></div>
              <div class="text">{{item}}</div>
              <div class="time">{{item}}</div>
            </li>
          </ul>
          <div class="btn-group">
            <span class="btn-text" @click="$router.push('/center/balance')">提现记录</span>
            <span class="btn-text" @click="$router.go(-1)">继续提现</span>
            <span class="btn-text" @click="$router.go(-2)">返回我的账户中心</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import navHeader from '@/components/navHeader.vue'
export default {
  components:{
    navHeader,
  },
  data(){
    return{
      steps:['提现申请','速派处理','提现成功'],
      current:1,
    }
  }
}
</script>
<style lang="scss">
.after-withdraw{
  .container{
    width: 1000px;
    margin: 0 auto;
    background-color: #fff;
    padding-top: 70px;
    overflow: hidden;
  }
  .dl{
    padding: 100px 150px;
    overflow: hidden;
    .dt{
      width: 60px;
      height: 60px;
      float: left;
      border-radius: 50%;
      // background-color: #f75959;
      background: url('~@/assets/balance/timer-icon.png') no-repeat center /contain;
      margin-right: 30px;
    }
    .dd{
      float: left;
    }
    .msg{
      font-size: 16px;
      color: #333;
      line-height: 24px;
      margin-bottom: 10px;
    }
    .desc{
      font-size: 12px;
      color: #999;
      line-height: 24px;
    }
  }
  .step-list{
    overflow: hidden;
    margin-bottom: 40px;
    margin-top: 40px;
    li{
      width: 180px;
      float: left;
      position: relative;
      // text-align: center;
      &:before{
        content: "";
        position: absolute;
        left: 10px;
        top: 16px;
        width: 100%;
        height: 4px;
        // border-radius: 4px;
        background-color: #d2d2d2;
      }
      &:last-child:before{
        display: none;
      }
      .num{
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background: linear-gradient(0deg, rgba(214, 214, 214, 0.7), rgba(222, 222, 222, 0.7));
        // margin: 0 auto;
        position: relative;
        i{
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%,-50%);
          font-size: 18px;
          font-weight: bold;
          color: #fff;
          font-family: arial;
          display: block;
          line-height: 28px;
          width: 28px;
          height: 28px;
          border-radius: 50%;
          text-align: center;
          background-color: #c9c9c9;
        }
      }
      .text{
        display: block;
        font-size: 14px;
        color: #333;
        line-height: 24px;
        margin-top: 12px;
      }
      .time{
        font-size: 14px;
        color: #999;
        line-height: 24px;
      }
      &.on{
        &:before{
          background-color: #FF5908;
        }
        .num{
          i{
            background-color: #FF5908;
          }
        }
        .text{
          color:#FF5908;
        }
      }
    }
  }
  .btn-group{
    white-space: nowrap;
    .btn-text{
      font-size: 14px;
      color: #00a0e9;
      line-height: 24px;
      display: inline-block;
      margin-right: 20px;
      cursor: pointer;
      &:hover{
        text-decoration: underline;
      }
    }
  }
}
</style>